import type { ListItem } from "@memorang/ui/components/ItemList";
import { ItemIcons } from "@memorang/ui/components/OnboardingApplet/FeatureItemIcon";
import PrivacyScreen from "@memorang/ui/components/PrivacyScreen";

import type { OnboardingDataItemType } from "@configs/custom-app-config-schema";
import i18n from "@helpers/lib/i18n";
import type { IconType } from "@memorang/ui/icon";
import { List } from "react-native-paper";
import { useOnboardingContext } from "../contexts/OnboardingContext";
import type { NextButtonHandler } from "../types";

type Props = {
	handleNextAction: NextButtonHandler;
	data: OnboardingDataItemType[];
	cta?: string;
};

export const PrivacyScreenContainer = ({
	handleNextAction,
	data,
	cta,
}: Props) => {
	const { stepsToShow } = useOnboardingContext();

	const hasChooseCategoryStep = stepsToShow?.some(
		(step) => step.step === "chooseCategory",
	);

	const handleNext = () => {
		handleNextAction(
			hasChooseCategoryStep ? "chooseCategory" : "chooseContext",
		);
	};

	const privacyItems: ListItem[] = data.map((item, index) => ({
		id: index.toString(),
		title: item.titlei18n?.[i18n.language] || "",
		description: item.descriptioni18n?.[i18n.language],
		customLeft: () => (
			<List.Icon icon={() => <ItemIcons nameIcon={item.icon as IconType} />} />
		),
	}));

	return (
		<PrivacyScreen items={privacyItems} onPrimaryPress={handleNext} cta={cta} />
	);
};
